import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import legend from "../../assets/img/legend.png";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  pushMeasureStat,
  pushDrawType,
  pushPoiInfoExpand,
  pushLegendSelected,
  pushSourceAIS,
  pushVesselSelected,
  pushPoiSelected,
  pushLayerAdd,
  pushZonaTarget,
  pushEarthQuake,
  pushVesselPtmSelected,
  pushWeatherChecked,
  pushBathymetryChecked,
  pushFilter
} from "../../actions/portal";
import {
  pushDrawData,
  pushFavorite,
  fetchSourceList,
  fetchCatshiptype,
  fetchLayers,
  fetchPoiCat,
  fetchZona,
  fetchZonabySearch,
  fetchEarthQuake,
  fetchUseForCat
} from "../../api/portal";

import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";

import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";

import Switch from "@material-ui/core/Switch";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControl } from "@material-ui/core";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from "@material-ui/core/Select";
import Button from "components/CustomButtons/Button.jsx";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import DraftsIcon from "@material-ui/icons/Drafts";
import SendIcon from "@material-ui/icons/Send";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import StarBorder from "@material-ui/icons/StarBorder";
import Dialog from "@material-ui/core/Dialog";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { NavLink, withRouter } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import _ from "lodash";

const style = theme => ({
  mapLegend: {
    position: "absolute",
    width: "15%",
    height: "50%",
    bottom: "10%",
    //left: "2%",
    zIndex: "5",
    padding: "5px",
    minWidth: "276px",
    border: "0px solid #999",
    [theme.breakpoints.down("sm")]: {
      width: "auto",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    }
  }
});

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "rgb(255, 223, 44, 0.5)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56
    }
  },
  content: {
    "&$expanded": {
      margin: "12px 0"
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiAccordionDetails);

let vesselSelected = [];
let poiSelected = [];
let zoneSelected = [];

class Legend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showStat: "block",
      poiContent: null,
      checkedA: false,
      typeDraw: "Point",
      drawsave: false,
      drawname: "",
      geojson: [],
      shipTypeString: "n/a",
      expoiinfo: false,
      expanded: "panel1",
      open: true,
      openZone: false,
      openGeofence: false,
      openGeofenceGeneral: false,
      openGeofenceOB: false,
      openGeofenceSpecific: false,
      openLayers: false,
      vesselType: [],
      layerAddList: [],
      openPoi: false,
      poicat: [],
      zone: [],
      zoneGeneral: [],
      zoneOB: [],
      zoneSpecific: [],
      filter: true,
      selectedUseForCat: "",
      useForCatData: [],
      loading: true,
      selectAll: false
    };
  }

  UNSAFE_componentWillMount() {}

  getDataAll = () => {
    fetchCatshiptype()
      .then(response => {
        let ship = response.data.results;

        this.setState({ vesselType: ship });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
    fetchLayers()
      .then(response => {
        let layerAddList = response.data.results;

        this.setState({ layerAddList: layerAddList });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });

    fetchPoiCat()
      .then(response => {
        let poicat = response.data.results;
        this.setState({ poicat: poicat });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });

    fetchZona()
      .then(response => {
        let zone = response.data.results;

        this.setState({ zone: zone });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });

    fetchUseForCat()
      .then(response => {
        if (response !== null) {
          let data = [];
          response.data.results.map(e => {
            if (
              e.usefor == "spesific" ||
              e.usefor == "outbar" ||
              e.usefor == "zona konservasi"
            ) {
              data.push({
                usefor: e.usefor
              });
            }
          });
          this.setState({
            useForCatData: data,
            selectedUseForCat: response.data.results[5].usefor
          });
        }
        fetchZonabySearch(this.state.selectedUseForCat)
          .then(response => {
            if (response !== null) {
              let zoneGeneral = response.data.results;

              this.setState({ zoneGeneral: zoneGeneral });
            }
            this.setState({ loading: false });
          })
          .catch(error => {
            console.log(error);
            // this.props.history.push("/pages/login#logout");
          });
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.pushLoader(false);
        // this.props.history.push("/pages/login#logout");
      });

    fetchZonabySearch("spesific")
      .then(response => {
        let zoneSpecific = response.data.results;

        this.setState({ zoneSpecific: zoneSpecific });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });

    fetchZonabySearch("outbar")
      .then(response => {
        let zoneOB = response.data.results;

        this.setState({ zoneOB: zoneOB });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      poiContent: nextProps.poiContent,
      drawData: nextProps.drawData,
      drawDataAll: nextProps.drawDataAll,
      expoiinfo: nextProps.expoiinfo,
      filter: nextProps.filter
    });

    if (nextProps.filter === false) {
      this.getDataAll();
    }
  }

  componentDidMount() {
    if (this.props.filter != true) {
      this.setState({ filter: false });
    }
    if (this.props.weatherChecked != true) {
      this.props.pushWeatherChecked(false);
    }
    if (this.props.bathymetryChecked != true) {
      this.props.pushBathymetryChecked(false);
    }
    this.props.pushLayerAdd(null);
  }

  renderUseFor = e => {
    return <MenuItem value={e.usefor}> {e.usefor} </MenuItem>;
  };

  handleuseforcat = e => {
    this.setState({ selectedUseForCat: e.target.value, loading: true });
    fetchZonabySearch(e.target.value)
      .then(response => {
        if (response !== null) {
          let zoneGeneral = response.data.results;
          this.setState({ zoneGeneral: zoneGeneral });
        }
        this.setState({ loading: false });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
  };

  handleClickClose = () => {
    this.setState({ filter: true });
    this.props.pushFilter(true);
  };

  handleChangeChecked = () => {
    this.props.pushMeasureStat(!this.state.checkedA);
    this.setState({
      checkedA: !this.state.checkedA
    });
  };

  handleChangeTypeDraw = event => {
    this.setState({ typeDraw: event.target.value });
    this.props.pushDrawType(event.target.value);
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  handleState = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  handleDrawname = e => {
    this.setState({ drawname: e.target.value });
  };

  handleSave = () => {
    pushDrawData(
      this.state.drawname,
      this.state.drawData,
      this.state.drawDataAll
    )
      .then(response => {
        console.log(response);
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
    this.setState({ drawsave: false });
  };

  handleExpand = () => {
    this.props.pushPoiInfoExpand(!this.props.expoiinfo);
  };

  handleChange = e => {
    console.log(e);
    //this.setState({expanded:e});
  };

  handleClick = () => {
    this.setState({ open: !this.state.open });
  };
  handleClickZone = () => {
    this.setState({ openZone: !this.state.openZone });
  };
  handleClickLayers = () => {
    this.setState({ openLayers: !this.state.openLayers });
  };
  handleClickGeofence = () => {
    this.setState({ openGeofence: !this.state.openGeofence });
  };
  handleClickGeofenceGeneral = () => {
    this.setState({ openGeofenceGeneral: !this.state.openGeofenceGeneral });
  };
  handleClickGeofenceOB = () => {
    this.setState({ openGeofenceOB: !this.state.openGeofenceOB });
  };
  handleClickGeofenceSpecific = () => {
    this.setState({ openGeofenceSpecific: !this.state.openGeofenceSpecific });
  };

  handleClickPoi = () => {
    this.setState({ openPoi: !this.state.openPoi });
  };

  handleCheckVessel = e => {
    const newdata = { val: e.target.value, checked: e.target.checked };
    let index = _.findIndex(vesselSelected, _.pick(newdata, "val"));

    if (index !== -1) {
      vesselSelected.splice(index, 1, newdata);
    } else {
      vesselSelected.push(newdata);
    }

    this.props.pushVesselSelected(vesselSelected);
  };

  handleCheckVesselPtm = e => {
    this.props.pushVesselPtmSelected(e.target.checked);
  };

  handleCheckLayer = e => {
    if (e.target.checked == false) {
      this.props.pushLayerAdd(null);
    } else {
      this.props.pushLayerAdd(e.target.value);
    }
  };

  handleCheckPoi = e => {
    let valnya = e.target.value.split("|");
    const newdata = {
      val: valnya[0],
      checked: e.target.checked,
      icon_path: valnya[1]
    };
    let index = _.findIndex(poiSelected, _.pick(newdata, "val"));

    if (index !== -1) {
      poiSelected.splice(index, 1, newdata);
    } else {
      poiSelected.push(newdata);
    }
    this.props.pushPoiSelected(poiSelected);
  };

  renderVessel = e => {
    return (
      <span>
        <br />
        <input
          type="checkbox"
          onChange={this.handleCheckVessel}
          value={e.shiptype}
        />{" "}
        <span>
          <img
            src={require("../../assets/poi/" + e.shiptype + ".png")}
            alt="Logo"
            height="25"
            width="25"
          />{" "}
          {" " + e.typename}
        </span>
      </span>
    );
  };

  handleCheckZone = e => {
    let val = e.target.value.split("|");
    const newdata = { val: val[1], checked: e.target.checked };
    let index = _.findIndex(zoneSelected, _.pick(newdata, "val"));

    if (index !== -1) {
      zoneSelected.splice(index, 1, newdata);
    } else {
      zoneSelected.push(newdata);
    }
    this.props.pushZonaTarget(zoneSelected);
  };

  renderZone = e => {
    return (
      <span padding="10">
        <input
          type="checkbox"
          onChange={this.handleCheckZone}
          value={e.id + "|" + e.geom}
        />{" "}
        <span>{e.name}</span>
        <br />
      </span>
    );
  };

  valueAll = e => {
    let content = [];
    this.setState({ selectAll: e.target.checked });
    this.state.zoneGeneral.forEach(item => {
      content.push({ val: item.geom, checked: e.target.checked });
      return content;
    });
    this.props.pushZonaTarget(content);
  };

  renderZoneGeofence = e => {
    return (
      <span padding="10">
        <input
          disabled={this.state.selectAll}
          type="checkbox"
          onChange={this.handleCheckZone}
          value={e.id + "|" + e.geom}
        />{" "}
        <span>{e.name}</span>
        <br />
      </span>
    );
  };

  renderButtonSave = e => {
    if (this.state.typeDraw == "Polygon") {
      return (
        <Button
          color="success"
          round
          onClick={() => this.handleClose("drawsave", true)}
        >
          Save Draw
        </Button>
      );
    } else {
      return false;
    }
  };

  renderLayers = e => {
    if (e.layer == null) {
      e.layer = "";
    }
    let val = `${e.url}|${e.layer}|${e.legend}|${e.name}`;
    return (
      <span padding="10">
        <br />
        <input
          type="checkbox"
          onChange={this.handleCheckLayer}
          value={val}
        />{" "}
        <span>{e.name}</span>
      </span>
    );
  };

  renderPoi = e => {
    return (
      <span padding="10">
        <br />
        <input
          type="checkbox"
          onChange={this.handleCheckPoi}
          value={e.category_name + "|" + e.icon_path}
          // defaultChecked={e.category_name === "port" ? true : false}
        />{" "}
        <span>{e.category_name}</span>
      </span>
    );
  };

  handleCheckWeather = e => {
    this.props.pushWeatherChecked(e.target.checked);
  };

  handleCheckBathymetry = e => {
    this.props.pushBathymetryChecked(e.target.checked);
  };

  handleCheckEarthQuake = e => {
    if (e.target.checked == true) {
      fetchEarthQuake()
        .then(response => {
          let infogempa = {
            gempa: response.data.results[0]
          };
          this.props.pushEarthQuake(infogempa);
        })
        .catch(error => {
          console.log(error);
          // this.props.history.push("/pages/login#logout");
        });
    } else {
      this.props.pushEarthQuake({});
    }
  };

  render() {
    const { classes } = this.props;
    const text = {
      color: "white"
    };

    return (
      <div
        style={{ display: this.props.filter ? "none" : this.state.showStat }}
        id="legend"
      >
        <div
          // style={mapLegend}
          className={classes.mapLegend}
        >
          <div
            hidden={this.state.filter}
            style={{
              width: "100%",
              padding: "0",
              height: "100%",
              overflow: "auto"
            }}
          >
            <Card
              style={{
                backgroundColor: "rgb(255, 246, 246, 0.8)"
              }}
            >
              <CardHeader
                action={
                  <IconButton
                    aria-label="close"
                    size="small"
                    edge="end"
                    onClick={this.handleClickClose}
                  >
                    <CloseIcon />
                  </IconButton>
                }
                style={{ color: "#4083FF", padding: 10 }}
              />
              <div>
                <List component="nav" aria-labelledby="nested-list-subheader">
                  <ListItem button onClick={this.handleClick}>
                    <ListItemText secondary="Ship Type" style={text} />
                    {this.state.open ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={this.state.open}>
                    <List
                      component="div"
                      disablePadding
                      style={{ paddingLeft: 20 }}
                    >
                      <span>
                        <br />
                        <input
                          type="checkbox"
                          onChange={this.handleCheckVesselPtm}
                          value={`99`}
                          defaultChecked={true}
                        />{" "}
                        <span>
                          <img
                            src={require("../../assets/poi/99.png")}
                            alt="Logo"
                            height="25"
                            width="25"
                          />{" "}
                          Pertamina
                        </span>
                      </span>
                      {this.state.vesselType.map(this.renderVessel)}
                    </List>
                  </Collapse>

                  <ListItem button onClick={this.handleClickZone}>
                    <ListItemText secondary="Drawing Tools" style={text} />
                    {this.state.openZone ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={this.state.openZone}>
                    <Typography>
                      <Switch
                        checked={this.state.checkedA}
                        onChange={this.handleChangeChecked}
                        value="checkedA"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                      Draw Active
                    </Typography>
                    <List component="div" disablePadding>
                      <div style={{ padding: 10 }}>
                        <FormControl
                          fullWidth
                          style={{ paddingLeft: 10, paddingRight: 10 }}
                        >
                          <Select
                            value={this.state.typeDraw}
                            onChange={this.handleChangeTypeDraw}
                          >
                            <MenuItem value={"Point"}>Point</MenuItem>
                            <MenuItem value={"LineString"}>LineString</MenuItem>
                            <MenuItem value={"Polygon"}>Polygon</MenuItem>
                            <MenuItem value={"Circle"}>Circle</MenuItem>
                          </Select>
                        </FormControl>
                        <FormControl fullWidth>
                          {this.renderButtonSave()}
                        </FormControl>
                      </div>
                    </List>
                  </Collapse>

                  {/*<Collapse in={this.state.openGeofence}>
                    <List
                      component="div"
                      disablePadding
                      style={{ paddingLeft: 20 }}
                    >
                      {this.state.zone.map(this.renderZone)}
                    </List>
                  </Collapse>
                  <ListItem button onClick={this.handleClickLayers}>
                    <ListItemText secondary="Layers" style={text} />
                    {this.state.openLayers ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>*/}
                  <ListItem button onClick={this.handleClickGeofenceGeneral}>
                    <ListItemText secondary="Geofence" style={text} />
                    {this.state.openGeofenceGeneral ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItem>

                  <Collapse in={this.state.openGeofenceGeneral}>
                    {this.state.loading ? (
                      <span style={{ paddingLeft: "18px" }}>Loading...</span>
                    ) : (
                      <div>
                        <FormControl
                          variant="standard"
                          style={{ paddingLeft: "18px", paddingBottom: "12px" }}
                        >
                          <Select
                            value={this.state.selectedUseForCat}
                            onChange={this.handleuseforcat}
                            style={{ fontSize: "14px" }}
                          >
                            {this.state.useForCatData.map(this.renderUseFor)}
                          </Select>
                        </FormControl>
                        <List
                          component="div"
                          disablePadding
                          style={{ paddingLeft: 20 }}
                        >
                          <span padding="10">
                            <input
                              type="checkbox"
                              onChange={this.valueAll}
                              value=""
                            />{" "}
                            <span>All</span>
                            <br />
                          </span>
                          {this.state.zoneGeneral.map(this.renderZoneGeofence)}
                        </List>
                      </div>
                    )}
                  </Collapse>

                  {/* <ListItem button onClick={this.handleClickGeofenceOB}>
                    <ListItemText secondary="Out Bar" style={text} />
                    {this.state.openGeofenceOB ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItem>

                  <Collapse in={this.state.openGeofenceOB}>
                    <List
                      component="div"
                      disablePadding
                      style={{ paddingLeft: 20 }}
                    >
                      {this.state.zoneOB.map(this.renderZone)}
                    </List>
                  </Collapse> */}

                  {/* <ListItem button onClick={this.handleClickGeofenceSpecific}>
                    <ListItemText secondary="Cruise Line" style={text} />
                    {this.state.openGeofenceSpecific ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItem>

                  <Collapse in={this.state.openGeofenceSpecific}>
                    <List
                      component="div"
                      disablePadding
                      style={{ paddingLeft: 20 }}
                    >
                      {this.state.zoneSpecific.map(this.renderZone)}
                    </List>
                  </Collapse> */}

                  <ListItem button onClick={this.handleClickLayers}>
                    <ListItemText secondary="Layers" style={text} />
                    {this.state.openLayers ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>

                  <Collapse in={this.state.openLayers}>
                    <List
                      component="div"
                      disablePadding
                      style={{ paddingLeft: 20 }}
                    >
                      {this.state.layerAddList.map(this.renderLayers)}
                      <span padding="10">
                        <br />
                        <input
                          type="checkbox"
                          onChange={this.handleCheckWeather}
                          value="weather"
                        />{" "}
                        <span>Weather</span>
                      </span>
                      <span padding="10">
                        <br />
                        <input
                          type="checkbox"
                          onChange={this.handleCheckBathymetry}
                          value="bathymetry"
                        />{" "}
                        <span>Bathymetry</span>
                      </span>
                    </List>
                  </Collapse>

                  <ListItem button onClick={this.handleClickPoi}>
                    <ListItemText secondary="Point of Interest" style={text} />
                    {this.state.openPoi ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={this.state.openPoi}>
                    <List
                      component="div"
                      disablePadding
                      style={{ paddingLeft: 20 }}
                    >
                      {this.state.poicat.map(this.renderPoi)}
                      <span padding="10">
                        <br />
                        <input
                          type="checkbox"
                          onChange={this.handleCheckEarthQuake}
                          value="earthquake"
                        />{" "}
                        <span>earth quake</span>
                      </span>
                      {/* <span padding="10">
                        <br />
                        <input
                          type="checkbox"
                          onChange={this.handleCheckWeather}
                          value="weather"
                        />{" "}
                        <span>weather</span>
                      </span> */}
                    </List>
                  </Collapse>
                </List>
              </div>
            </Card>
          </div>
        </div>
        <Dialog
          aria-labelledby="simple-dialog-title"
          open={this.state.drawsave}
          onClose={() => this.handleClose("drawsave", false)}
        >
          <GridItem xs={12} sm={12} md={12}>
            <CustomInput
              labelText="Area Name"
              id="areaname"
              inputProps={{
                value: this.state.drawname,
                onChange: this.handleDrawname
              }}
              formControlProps={{
                fullWidth: true
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl fullWidth>
              <Button color="default" onClick={this.handleSave}>
                Save
              </Button>
            </FormControl>
          </GridItem>
        </Dialog>
      </div>
    );
  }
}

Legend.propTypes = {
  classes: PropTypes.object.isRequired,
  basemapLegend: PropTypes.string,
  pushMeasureStat: PropTypes.bool,
  pushDrawType: PropTypes.string,
  pushLoader: PropTypes.bool,
  pushPoiInfoExpand: PropTypes.bool,
  expoiinfo: PropTypes.bool,
  pushVesselSelected: PropTypes.array,
  pushPoiSelected: PropTypes.array,
  pushZonaTarget: PropTypes.array,
  pushVesselPtmSelected: PropTypes.bool,
  pushEarthQuake: PropTypes.array,
  pushWeatherChecked: PropTypes.array,
  pushBathymetryChecked: PropTypes.array,
  pushFilter: PropTypes.bool,
  pushLayerAdd: PropTypes.string
};

function mapStateToProps(state) {
  return {
    blocking: state.loader,
    basemapLegend: state.basemapLegend,
    bottomLegendPanel: state.bottomLegendPanel,
    poiContent: state.poiContent,
    drawData: state.drawData[0],
    drawDataAll: state.drawDataAll,
    expoiinfo: state.poiInfoExpand,
    filter: state.filter
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      pushVesselSelected,
      pushMeasureStat,
      pushDrawType,
      pushLayerAdd,
      pushPoiSelected,
      pushZonaTarget,
      pushEarthQuake,
      pushVesselPtmSelected,
      pushWeatherChecked,
      pushBathymetryChecked,
      pushFilter
    }
  )(withStyles(style)(Legend))
);
